interface CsvColumn<RowType> {
  key: keyof RowType;
  label: string;
}

const escapeCsvField = (value: unknown): string => {
  if (value === null || value === undefined) {
    return "";
  }

  const normalized = String(value);
  if (/[,"\n\r]/.test(normalized)) {
    return `"${normalized.replace(/"/g, '""')}"`;
  }

  return normalized;
};

export const buildCsvFromRows = <RowType extends Record<string, unknown>>(
  rows: RowType[],
  columns: CsvColumn<RowType>[]
): string => {
  const header = columns.map((column) => escapeCsvField(column.label)).join(",");

  const body = rows.map((row) =>
    columns
      .map((column) => escapeCsvField(row[column.key]))
      .join(",")
  );

  return [header, ...body].join("\n");
};

export const downloadCsv = (fileName: string, csvText: string): void => {
  const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = blobUrl;
  link.download = fileName;
  link.style.display = "none";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
};
